export const teamCard = {
  team: {
    teamId: 'GN7VASH15HKYQA7',
    name: 'Costa de Marfil',
    shortName: 'Costa de Marfil',
    crestUrl: 'https://cdn.example.com/teams/civ/crest.png',
    flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CIV_flag.png',
    primaryHex: '#F77F00',
    isFavorite: true,
  },
  recentResults: [
    { matchOrder: 1, result: 'DRAW', label: 'E' },
    { matchOrder: 2, result: 'LOSS', label: 'P' },
    { matchOrder: 3, result: 'WIN', label: 'G' },
    { matchOrder: 4, result: 'WIN', label: 'G' },
    { matchOrder: 5, result: 'WIN', label: 'G' },
  ],
  featuredPlayers: [
    {
      category: 'goals',
      headline: 'Goles',
      player: {
        playerId: 'civ-fw-009',
        name: 'Sébastien Haller',
        position: 'Delantero',
        number: 22,
        image: 'https://cdn.example.com/players/civ-fw-009.png',
        value: 8,
      },
    },
    {
      category: 'shotsTotal',
      headline: 'Tiros totales',
      player: {
        playerId: 'civ-fw-019',
        name: 'Nicolas Pépé',
        position: 'Delantero',
        number: 19,
        image: 'https://cdn.example.com/players/civ-fw-019.png',
        value: 8,
      },
    },
  ],
  summary: {
    matches: 8,
    points: 24,
  },
};
